export default __webpack_public_path__ + "static/media/vitalik_poap_3.0c0bdb99.svg";